module.exports = {
  headline: 'Etiska riktlinjer',
  index: [
    'Spotins Etiska riktlinjer',
    'Referenser', 
  ],
  guidelines: `
    <p>
      Spotin samarbetar med en rad leverantörer av produkter, och partners is form av medieanvändare, 
      samt med betalningstjänsteförmedlare som tredjepart. Betalningstjänsteförmedlare som i sin tur kan
      använda sig av underleverantörer för individuella betalningsmetoder.
    </p>

    <p>
      Alla samarbetande användare av Spotin måste följa Spotin's etiska riktlinjer såväl som riktlinjer som
      är ställda på Spotin via tjänster i tredjepart som Spotin använder sig av, ex. betalningsförmedlingtjänster.
    </p>

    <p>
      Spotins etiska riktlinjer kommer att läggas till här inom kort...
    </p>

    <h2 anchor>
      Referenser
    </h2>
    <p>
      Nedan kan du finna länkar till riktlinjer till externa parter som är gällande för alla leverantörer och medie-
      aktörer som använder Spotin.
    </p>

    <a href="https://cdn.klarna.com/1.0/shared/content/policy/ethic/en_gb/merchant.pdf">Klarna Ethical Guidelines</a>
  `,
};


// WEBPACK FOOTER //
// ./pages/content/ethicalGuidelines_SV.js